import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 運用状態 */
enum OperationalStatus {
  before = '1',
  after = '2',
}

const nameConfig = {
  before: new Map([
    [Locale.ja, '運用開始前'],
    [Locale.en, 'Before Operation Start'],
  ]),
  after: new Map([
    [Locale.ja, '運用開始後'],
    [Locale.en, 'After Operation Start'],
  ]),
};

const toEnum = rawValueToEnum(OperationalStatus, OperationalStatus.after);
const toDisplay = enumToName(OperationalStatus, nameConfig);

export const operationalStatus = {
  enum: OperationalStatus,
  nameConfig,
  toEnum,
  toDisplay,
};

export type { OperationalStatus };
